import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {
	TextField,
	Typography,
	Grid,
	Button,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,

	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { Card } from "reactstrap";
import { IoMdSend } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Alert } from "reactstrap";
import { addOrUpdateUserWithdrawLimit } from "../../redux/actions/addOrUpdateUserWithdrawLimitAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SaveIcon from "@mui/icons-material/Save";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import { getStoreList } from "../../redux/actions/getStoreListAction";
import {
	resetGetCustomerIdAndNameList,
	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const WLAddWithdrawLimit = () => {
	const [customerId, setCustomerId] = useState("");
	const [currency, setCurrency] = useState("");
	const [level, setLevel] = useState("");
	const [dailyAmountLimit, setDailyAmountLimit] = useState("");
	const [weeklyAmountLimit, setWeeklyAmountLimit] = useState("");
	const [monthlyAmountLimit, setMonthlyAmountLimit] = useState("");
	const [yearlyAmountLimit, setYearlyAmountLimit] = useState("");
	const [addUserWithdrawLimitRes, setaddUserWithdrawLimitRes] = useState("");
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const addOrUpdateUserWithdrawLimitRes = useSelector(
		({ addOrUpdateUserWithdrawLimit }) => addOrUpdateUserWithdrawLimit
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	// console.log(
	// 	"addOrUpdateUserWithdrawLimitRes",
	// 	addOrUpdateUserWithdrawLimitRes
	// );

	const handleChange = ({ target: { name, value } }) => {
		if (name === "customerId") {
			setCustomerId(value);
		}

		if (name === "currency") {
			// setCurrency(value);
			setCurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "level") {
			// setLevel(value);
			setLevel(value == "Select Level" ? "" : value);
		}

		if (name === "DailyAmountLimit") {
			//setDailyAmountLimit(value);
			Util.verifyAmount(value)
				? setDailyAmountLimit(value)
				: setDailyAmountLimit(dailyAmountLimit);
		}

		if (name === "WeeklyAmountLimit") {
			// setWeeklyAmountLimit(value);
			Util.verifyAmount(value)
				? setWeeklyAmountLimit(value)
				: setWeeklyAmountLimit(weeklyAmountLimit);
		}

		if (name === "MonthlyAmountLimit") {
			//  setMonthlyAmountLimit(value);
			Util.verifyAmount(value)
				? setMonthlyAmountLimit(value)
				: setMonthlyAmountLimit(monthlyAmountLimit);
		}

		if (name === "YearlyAmountLimit") {
			//  setYearlyAmountLimit(value);
			Util.verifyAmount(value)
				? setYearlyAmountLimit(value)
				: setYearlyAmountLimit(yearlyAmountLimit);
		}
	};

	const addUserWithdrawLimitFunc = () => {
		setaddUserWithdrawLimitRes(true);
		const addUserWithdrawLimitReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerId.split("-")[0],
				currency: currency,
				level: level,
				dailyLimit: dailyAmountLimit,
				weeklyLimit: weeklyAmountLimit,
				monthlyLimit: monthlyAmountLimit,
				yearlyLimit: yearlyAmountLimit,
				limitId: ""
			}
		};

		return dispatch(
			addOrUpdateUserWithdrawLimit(addUserWithdrawLimitReq, authToken)
		);
	};

	useEffect(() => {
		if (addUserWithdrawLimitRes) {
			addOrUpdateUserWithdrawLimitResFunc();
		}
	}, [addOrUpdateUserWithdrawLimitRes.data.status]);

	const addOrUpdateUserWithdrawLimitResFunc = () => {
		if (addUserWithdrawLimitRes) {
			if (addOrUpdateUserWithdrawLimitRes.data.status == "success") {
				setaddUserWithdrawLimitRes(addOrUpdateUserWithdrawLimitRes.data);
				setNotificationOpen(true);
			}
			if (addOrUpdateUserWithdrawLimitRes.data.status == "failed") {
				setaddUserWithdrawLimitRes(addOrUpdateUserWithdrawLimitRes.data);
				setNotificationOpen(true);
				if (
					addOrUpdateUserWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateUserWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (addOrUpdateUserWithdrawLimitRes.data.status == "Failed") {
				setaddUserWithdrawLimitRes(addOrUpdateUserWithdrawLimitRes.data);
				setNotificationOpen(true);
				if (
					addOrUpdateUserWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateUserWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	
	const filterOptions = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	// const filterOptions = createFilterOptions({
	// 	matchFrom: "any",
	// 	limit: 500
	// });

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);

	useEffect(() => {
		const getCustomerIdAndNameReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerNameOrId: ""
			}
		};

		dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
	}, []);

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid container>
						<Grid item lg={2} md={2}></Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					<Grid container>
						<Grid item lg={12} md={12} sm={12}>
							<h6 align="center" className="text-center mt-3 themeText ">
								Add User Withdraw Limit
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							{/* <div style={{ marginTop: "1.5rem" }}>
                <TextField
                  required
                  type="text"
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="Customer ID"
                  fullWidth={true}
                  name="customerId"
                  value={customerId || ""}
                  onChange={handleChange}
                />
              </div> */}

							<div style={{ marginTop: "1.5rem" }}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getCustomerIdAndNameListRes.data.currencyList || [""]
									)}
									getOptionLabel={(option) => option}
									filterOptions={filterOptions}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Customer ID"
											variant="standard"
											required
											type="text"
											fullWidth
											{...params}
											value={customerId || ""}
											name="customerId"
											onBlur={handleChange}
											sx={{
												"& .MuiInput-underline:before": {
												  borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												  borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
												  borderBottomColor: "gray", // White color after focus
												},
											  }}
										/>
									)}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									label="Currency"
									variant="standard"

									fullWidth={true}
									name="currency"
									// value={currency || ""}
									defaultValue={"Select Currency" || currency}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Currency" selected="Select Currency">
										Select Currency
									</MenuItem>

									{adminCurrencyList.success &&
										[]
											.concat(adminCurrencyList.data.currencyList)
											.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									label="Level"
									variant="standard"

									fullWidth={true}
									name="level"
									// value={level || ""}
									defaultValue={"Select Level" || level}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Level" selected="Select Level">
										Select Level
									</MenuItem>
									<MenuItem value="BASIC">BASIC</MenuItem>
									<MenuItem value="STANDARD">STANDARD</MenuItem>
									<MenuItem value="PREMIUM">PREMIUM</MenuItem>
									<MenuItem value="SUPREME">SUPREME</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									size="small"
									color="primary"
									required
									autoFocus={true}
									variant="standard"

									label="Daily Amount Limit"
									fullWidth={true}
									name="DailyAmountLimit"
									value={dailyAmountLimit || ""}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									required
									size="small"
									color="primary"
									autoFocus={true}
									variant="standard"

									label="Weekly Amount Limit"
									fullWidth={true}
									reqruired
									name="WeeklyAmountLimit"
									value={weeklyAmountLimit || ""}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									size="small"
									required
									color="primary"
									variant="standard"

									autoFocus={true}
									label="Monthly Amount Limit"
									fullWidth={true}
									name="MonthlyAmountLimit"
									value={monthlyAmountLimit || ""}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								></TextField>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									required
									size="small"
									color="primary"
									variant="standard"

									autoFocus={true}
									label="Yearly Amount Limit"
									fullWidth={true}
									name="YearlyAmountLimit"
									value={yearlyAmountLimit || ""}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>

							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								{/* <Button
									style={{
										// marginLeft: "0.7rem",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									// color="primary"
									onClick={addUserWithdrawLimitFunc}
									endIcon={<SaveIcon />}
								>
									Save
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={addUserWithdrawLimitFunc}
									endIcon={<SaveIcon />}
								>
									Save <SaveIcon />
								</CustomButton>
							</div>
						</Grid>

						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>
			</Layout>

			{addUserWithdrawLimitRes.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addUserWithdrawLimitRes.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addUserWithdrawLimitRes.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addUserWithdrawLimitRes.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{addUserWithdrawLimitRes.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addUserWithdrawLimitRes.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default WLAddWithdrawLimit;
